import React,{Component} from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"

import * as companyActions from '../../actions/companyActions'
import moment from "moment/moment"
import $ from "jquery"


import './style.css';
import Spinner from '../Shared/Spinner'
import Product from './Product'
import Filters from './Filters'
import Pager from '../Shared/Pager'
import {CookiesSettings} from '../../helpers/cookiesHelper'
import SearchInput from '../Shared/SearchInput'
import NoBindings from './NoBindings'
import Checkbox from '../Shared/Checkbox'
import ConfirmModal from '../Shared/ConfirmModal'

let cookiesSetting = new CookiesSettings("company")

let timer

class Company extends Component{
    constructor(props){
        super(props);
        let id = props.match.params.id;
        let {company} = this.props;

        let showFilters = cookiesSetting.get("showFilters");
        if(showFilters == undefined){
            showFilters = true
            cookiesSetting.set("showFilters",showFilters)
        }

        //this.funcGetCompanies()

        this.state= {
            showFilters:showFilters,
            isAllChecked:false,
            checkedIds:[]
        }
    }
    componentWillReceiveProps(newProps){
        // let newId = newProps.match.params.id;
        // let oldId =  this.props.match.params.id;
        // let {company,companyActions} = this.props;
        //
        // if(newId !== oldId){ //обновить компанию при выборе другой
        //     if(!company.fetching) {
        //         this.funcGetCompanies(newId)
        //     }
        //
        // }
    }
    componentDidUpdate(){
        let {company} = this.props;
        if(company.needRefresh && !company.fetching && company.id != null) {
            this.funcGetCompanies()
            this.setState({
                isAllChecked:false,
                checkedIds:[]
            })
        }
    }
    componentWillMount(){

    }
    componentWillUnmount(){
        let {companyActions} = this.props
        companyActions.Reset()
    }

    handleToggleFilters() {
        cookiesSetting.set("showFilters",!this.state.showFilters)
        this.setState({
            showFilters: !this.state.showFilters
        });
    }
    handleCountChange(e) {
        let { company, companyActions } = this.props;
        companyActions.ChangeCount(e.target.value);
    }
    handleSearchOnChange(e){
        let { company, companyActions } = this.props;

        let value = e.target.value;
        companyActions.Change("offerId",value);


        clearTimeout(timer);
        timer =  setTimeout(()=>{
            companyActions.Change("page",1);
            companyActions.Change("total",0);
            companyActions.Change("needRefresh",true);
        },600)
    }
    handleOnFiltersChange(filters){
        let { companyActions } = this.props;

        companyActions.FiltersChange(filters);
    }
    handleOnFiltersFieldToggle(field){
        let { company } = this.props;

        let filters = company.filters;
        let newFilters = {
            ...filters,
            [field]:!filters[field]
        }
        this.handleOnFiltersChange(newFilters)
    }
    handleOnFiltersFieldChange(field,value){
        let { company } = this.props;

        let filters = company.filters;

        let newFilters = {
            ...filters,
            [field]:value
        }
        this.handleOnFiltersChange(newFilters)
    }

    handleFiltersReset() {
        let { companyActions } = this.props;
        companyActions.FiltersReset();
    }
    handlePagerChange(pager) {
        let { companyActions } = this.props;
        companyActions.Change("page",pager.page);
        companyActions.Change("needRefresh",true);
    }
    handleOnChangeOffer(offer){
        let { companyActions } = this.props;
        companyActions.OfferChange(offer);
    }
    handleFieldChange(field,value){
        let { companyActions } = this.props;
        companyActions.Change(field,value);
        if(["id","companyBindToId"].indexOf(field) !== -1){
            if(!value){
                companyActions.ResetData()
            }else{
                companyActions.Change("needRefresh",true);
            }

        }
    }
    handleOnResetBindings(){
        let { companyActions } = this.props;
        companyActions.ResetData();
    }
    handleAllCheckedChange(checked){
        let {company} = this.props
        let checkedIds = []

        if(checked){
            company.data.forEach((elem)=>{
                if(elem.offerId !== null){
                    checkedIds.push(elem.offerBindToId)
                }
            })
        }

        this.setState({
            isAllChecked:checked,
            checkedIds:checkedIds
        })
    }
    handleRemoveSelected(){
        let {company, companyActions} = this.props
        let checkedIds = this.state.checkedIds

        let data = company.data.filter((f)=>{
            return checkedIds.indexOf(f.offerBindToId) !== -1
        });

        if(data.length > 0){
            companyActions.RemoveBindings(data);
        }
    }
    handleBindingingFileChange(e){
        let {companyActions} = this.props
        companyActions.UploadBindings(e.target.files[0]);
        
    }
    onCheckboxChange(offerBindToId){
           let checkedIds = this.state.checkedIds;

           let index = checkedIds.indexOf(offerBindToId);
           if(index !== -1){
              checkedIds.splice(index,1)
           }else{
               checkedIds.push(offerBindToId);
           }

        this.setState({
            isAllChecked:false,
            checkedIds:checkedIds
        })
    }

    funcGetCompanies(){
        let {company,companyActions} = this.props;
            companyActions.Get(
                company.companyBindToId,
                company.id,
                (company.page-1) * company.count,
                company.count,
                company.offerId,
                company.filters
            );

    }

    templateShown() {
        let { company } = this.props;

        let total = company.total;
        let from = total !== 0 ? (((company.page - 1) * company.count) + 1) : 0;
        let to = company.page * company.count;
        if (to > total) {
            to = total;
        }
        return total !== 0? <span>Показанно с {from} по {to} из {total }</span> : null;
    }

    render(){
        let {company,companies,profile} = this.props;
        let companyId = company.id;

        let companyName = "";
        companies.data.forEach((item)=>{
            if(item.id == companyId){
                companyName = item.name
            }
        })

        let className = "content company-page";
        if(company.fetching){
            className += " fetching";
        }

        let bindingFileName =( company.bindingFile &&  company.bindingFile !== null) ? company.bindingFile.name : "Файл не выбран"

        return(
            <React.Fragment>

                <div className={className}>

                    {
                    company.fetching ?
                        <Spinner
                            styles={{
                                backgroundColor: "#37474F"
                            }}
                            className="fixed-bottom"
                        />
                        : null
                }

                    <div className="table-wrapp">

                        <div className="datatable-header">
                            <div className="form-horizontal">
                            <div className="row">
                                <div className="col-sm-4">

                                        {
                                            (profile.roles.indexOf("Admin") !== -1) ?
                                                <div className="companies-search">
                                                    <label className=" control-label">Основная компания</label>
                                                    <SearchInput
                                                        className=""
                                                        apiUrl="https://api.xmldatafeed.com/companies/all?name="
                                                        onObjectChange={(obj) =>
                                                            this.handleFieldChange("companyBindToId", obj.id)
                                                        }
                                                        // outObject={this.state.data.City}
                                                        // value={this.state.data.City.Value != null ? this.state.data.City.Value : ""}
                                                        placeholder="Начните вводить название"
                                                        mapping={{
                                                            id:"id",
                                                            value:"{name} <br> ({url})",
                                                            shownValue:"{name}",
                                                            dataFieldName:"content.companies"
                                                        }}
                                                    />
                                                </div>
                                                :null


                                        }
                                        <div className="companies-search">
                                            <label className=" control-label">Компания</label>
                                            <SearchInput
                                                className=""
                                                apiUrl="https://api.xmldatafeed.com/companies/all?name="
                                                onObjectChange={(obj) =>
                                                    this.handleFieldChange("id", obj.id)
                                                }
                                                // outObject={this.state.data.City}
                                                // value={this.state.data.City.Value != null ? this.state.data.City.Value : ""}
                                                placeholder="Начните вводить название"
                                                mapping={{
                                                    id:"id",
                                                    value:"{name} <br> ({url})",
                                                    shownValue:"{name}",
                                                    dataFieldName:"content.companies"
                                                }}
                                            />
                                        </div>
                                        

                                </div>
                                <div className="col-sm-4">

                                        <NoBindings/>

                                </div>
                                <div className="col-sm-3">  
                                    <div className="form-group">
                                        <label>Файл со связками: </label>
                                        <div className="uploader">
                                            <input type="file" className="file-styled"  onChange={(e)=>this.handleBindingingFileChange(e)} ref={(input)=>this.bindingFile = input}/>
                                            <span className="filename" >{bindingFileName}</span>
                                            <span className="action btn btn-default" >Выберите файл</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>

                            <div className="controls">
                                <div className="left-controls">

                                    <div className="search">
                                        <div className="form-group has-feedback">
                                            <input type="text" value={company.offerId} className="form-control" placeholder="Поиск по коду" onChange={(e) => this.handleSearchOnChange(e)}/>
                                            <div className="form-control-feedback">
                                                <i className="icon-search4 text-size-base"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="filter-bnt">
                                        <button type="button" className="btn btn-link" onClick={() => this.handleToggleFilters()}>
                                            Фильтр
                                            {
                                                this.state.showFilters ?
                                                    <i className="fa fa-sort-up"></i>
                                                    : <i className="fa fa-sort-down"></i>
                                            }

                                        </button>
                                    </div>
                                </div>

                                <div className="right-controls">
                                    <div className="count">
                                        <label>
                                            <span>Показывать:</span>
                                        </label>
                                        <select className="select form-control" value={company.count} onChange={(e) => this.handleCountChange(e)}>
                                            <option value="15">15</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                        </div>
                        {
                            this.state.showFilters ?
                                <Filters
                                    data={company.filters}
                                    onFiltersChange={(filters) => this.handleOnFiltersChange(filters)}
                                    onReset={() => this.handleFiltersReset()}
                                />
                                :null
                        }
                        {
                            company.uploadResult.length > 0 ? 
                            <div className="table-responsive">
                                <br/>
                                <button className="btn btn-reset" onClick={() => this.handleOnResetBindings()}>Очистить результат загрузки</button>
                            
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Результат загрузки</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                             company.uploadResult.length > 0 ? 
                                                company.uploadResult.map((result,index) => {
                                                    return(
                                                    <tr key={index}>
                                                        <td>{result}</td>
                                                    </tr>
                                                    );
                                                })
                                                : null
                                        }
                                    
                                    </tbody>
                                </table>
                            </div>
                            : null
                        }
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                <tr>
                                    {
                                        company.data.length > 0?
                                            <th>
                                                <div className="thead-actions">
                                                    <Checkbox
                                                        value={this.state.isAllChecked}
                                                        onChange={(checked)=>this.handleAllCheckedChange(checked)}
                                                    />
                                                    <div className="dropdown">
                                                        <a className="dropdown-toggle" data-toggle="dropdown">
                                                            <i className="icon-menu9"></i>
                                                        </a>

                                                        <ul className="dropdown-menu">
                                                            <li>
                                                                <ConfirmModal
                                                                    onConfirm={()=>this.handleRemoveSelected()}
                                                                    okText="Удалить"
                                                                    cancelText="Отменить"
                                                                    title="Удаление привязок"
                                                                    description={`Вы действительно хотите удалить отмеченные привязки ? Это действие нельзя будет отменить`}
                                                                >
                                                                    <a href="" ><i className="icon-cross2"></i> Удалить отмеченные</a>
                                                                </ConfirmModal>

                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>




                                            </th>
                                            :null
                                    }

                                    <th>Внутренний код</th>
                                    <th>Название</th>
                                    <th>Название конкурента</th>
                                    <th>Коэффициент</th>
                                    <th>Внутренний код конкурента</th>
                                    <th>Ссылка на товар</th>
                                    <th>Ссылка на товар конкурента</th>                                    
                                    <th>
                                        {/*<div className="checkbox auto-binded">*/}
                                            {/*<label title="Показывать только автоматически привязанные товары">*/}
                                                {/*<input*/}
                                                    {/*type="checkbox"*/}
                                                    {/*checked={company.filters.onlyAutoBinded}*/}
                                                    {/*onChange={(e)=>this.handleOnFiltersFieldToggle("onlyAutoBinded")}*/}
                                                {/*/>*/}
                                                {/*<span className="cr"><i className="cr-icon fa fa-check"></i></span>*/}
                                                {/*<i className="fa fa-laptop text-warning-300"></i>*/}
                                            {/*</label>*/}
                                        {/*</div>*/}

                                    </th>
                                    <th>Цена</th>
                                    <th>Цена конкурента</th>
                                    <th>Дата добавления</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    company.data.length > 0 ?
                                        company.data.map((offer,index) => {
                                            let key = (offer.offerBindToId ? offer.offerBindToId.toString() : "") + index.toString()
                                            let th = this;
                                            let isChecked= ()=>{
                                                let indexOf = th.state.checkedIds.indexOf(offer.offerBindToId);
                                                return indexOf !== -1
                                            }

                                            return (
                                                <Product
                                                    data={offer}
                                                    key={key}
                                                    companyId={companyId}
                                                    onChangeOffer={(offer)=> this.handleOnChangeOffer(offer)}
                                                    checked={isChecked()}
                                                    onCheckboxChange={(checked)=>{this.onCheckboxChange(offer.offerBindToId)}}
                                                />
                                            );
                                        })
                                        : company.set ?
                                        <tr>
                                            <td colSpan="6">
                                                Нет данных
                                            </td>
                                        </tr>
                                        :null
                                }
                                </tbody>
                            </table>
                        </div>
                        <div className="datatable-footer">
                            <div className="dataTables_info">
                                {this.templateShown()}
                            </div>
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_3_paginate">
                                {
                                    company.total > company.count?
                                        <Pager
                                            pager={{
                                                page: company.page,
                                                count: company.count,
                                                total: company.total
                                            }}
                                            onPageChange={(pager) => this.handlePagerChange(pager)}
                                        />
                                        :null
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>


        );
    }
}

function mapStateToProps(state) {
    return{
        company:state.company,
        companies:state.companies,
        profile:state.profile,

    }
}

function mapDispatchToProps(dispatch) {
    return{
        companyActions:bindActionCreators(companyActions,dispatch)
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Company);


// WEBPACK FOOTER //
// ./src/components/Company/index.jsx